import { Component } from '@angular/core';
import { BeesHeaderComponent } from "../bees-header/bees-header.component";
import { BeesFooterComponent } from "../bees-footer/bees-footer.component";
declare var $: any;
@Component({
  selector: 'app-page-about',
  standalone: true,
  imports: [BeesHeaderComponent, BeesFooterComponent],
  templateUrl: './page-about.component.html',
  styleUrl: './page-about.component.scss'
})
export class PageAboutComponent {
 ngAfterViewInit(): void {

    $('.team-two__carousel').owlCarousel({
      loop: true,
      margin: 30,
      nav: false,
      dots: true,
      autoplay: true,
      autoplayTimeout: 3000,
      smartSpeed: 1000,

      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        992: {
          items: 4
        }
      }
    });

  }
}
